import { type ComponentProps } from 'react';
import { Select as HeroSelect } from '@heroui/react';
import { cn } from '../utils';

const Root = <T extends object = object, M extends 'single' | 'multiple' = 'single'>({
  className,
  fullWidth = true,
  variant = 'secondary',
  ...props
}: ComponentProps<typeof HeroSelect.Root<T, M>>) => (
  <HeroSelect.Root<T, M>
    fullWidth={fullWidth}
    variant={variant}
    className={cn('min-w-0', className)}
    {...props}
  />
);

const Trigger = ({ className, ...props }: ComponentProps<typeof HeroSelect.Trigger>) => (
  <HeroSelect.Trigger className={cn('min-h-10', className)} {...props} />
);

const Popover = ({ className, ...props }: ComponentProps<typeof HeroSelect.Popover>) => (
  <HeroSelect.Popover
    className={cn('shadow-[0_24px_60px_-30px_rgb(15_23_42_/_0.55)]', className)}
    {...props}
  />
);

export const Select = Object.assign(Root, {
  Root,
  Trigger,
  Value: HeroSelect.Value,
  Indicator: HeroSelect.Indicator,
  Popover
});
